<template>
    <div class="container">

        <!-- Loading加载 -->
        <div class="loading" v-if="isDetail">
            <van-loading size="40px" type="spinner" color="#39CCCD" vertical>
                <div class="loading-text">
                    <div>页面正在加载</div>
                    <div>请稍候</div>
                </div>
            </van-loading>
        </div>

        <!-- 详情 -->
        <div class="content" v-html="detail.detail" v-show="!isDetail">
        </div>
        <div class="footer-fit" v-if="detail.id && !isDetail">
            <div class="bottom" @click.stop="returnWX()">
                <div class="bottom2">限时0元领取</div>
            </div>
        </div>  

        <!-- 页面前往微信 -->
        <div class="qianwang_mengceng" v-if="!isWXxcx && !isDetail && isQianwang" @click="isQianwang = false">
            <div class="qianwang" @click="isQianwang = true">
                <div class="qw_top">
                    <img src="@/assets/logo1.png" class="img_log" />
                    <div class="dotting">
                        <div :class="dot == 1 ? 'yuan' : 'yuan2'"></div>
                        <div :class="dot == 2 ? 'yuan' : 'yuan2'"></div>
                        <div :class="dot >= 3 ? 'yuan' : 'yuan2'"></div>
                    </div>
                    <img src="@/assets/weixin_logo.png" class="img_log" />
                </div>
                <div style="padding-top: 25px;">即将前往微信小程序完成领取噢~</div>
            </div>
        </div>

         <!-- 弹幕  -->
         <!-- <div class="danmu" :class="isDanmu ? 'fade-out' : 'fade-in'" v-if="!isDetail">
            <img :src="danmus.img" style="width: 20px;height: 20px;border-radius: 50px;" />
            <div style="padding: 0 10px;">{{ danmus.name }}</div>
            <div>{{ danmus.time }}</div>
            <div>领取了课程</div>
        </div> -->

        <DanmuView v-if="!isDetail" wenAn="领取了课程"></DanmuView>

    </div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script>
var that;
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'; 
import DanmuView from '@/components/danmuView/danmuView.vue';
export default {
    name: 'index_two', 
    components: {
        DanmuView
    },
    props: {},
    data() {
        return {
            id: '',
            bdVid: '',
            keywordid: '',
            isDetail: true,
            detail: {},
            isWXxcx: false,
            isQianwang: false,
            dot: 1,
            danmus: {
                img: require('@/assets/avatar2.jpg'),
                name: '陈*',
                time: '5秒前'
            },
            isDanmu: false,

        }
    },
    computed: {},
    created() {
        that = this
        that.id = this.$route.query.channel_id;
        that.bdVid = this.$route.query.bd_vid || '';
        that.keywordid = this.$route.query.keywordid || '';
        that.getDetail() 
        // setInterval(() => {
        //     that.getPhone()
        // }, 5000);
    },
    watch : {
        'isQianwang'(x,j) {
            if(x){
                setInterval(() => {
                    that.dot++
                    if(that.dot > 3){
                        that.dot = 1
                    }
                }, 300);
            }
        }
    },
    methods: {      
        async getDetail() {
            const res = await this.$http.get('/app/channels/getInfo', {
                id: this.id
            })
            console.log(res)
            if (res.code == 200) {
                this.detail = res.data;
                this.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
                // this.getCoursesDetail(res.data.courseId)
                document.title = res.data.title;
                setTimeout(() => {
                    this.isDetail = false;
                }, 500);
            } else {
                setTimeout(() => {
                    this.isDetail = false;
                    Toast('网络出现问题，请刷新重试!');
                }, 3000);
            }
        },

        // 获取课程详情
        getCoursesDetail(id) {
            var that = this;
            this.$http.get('/u/app/courses/detail', {
                id: id
            }).then(res => {
                console.log("数据" + res)
                that.detail.purchased = res.data.purchased;
                if(res.data.purchased){
					that.getAgainCourse()
				}
            })
        }, 
        
		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
			})
		},

        //跳转微信小程序打开
        returnWX() {  
            this.isQianwang = true;
            setTimeout(() => {
                this.isQianwang = false;
            }, 5000);
            this.$http.get('/u/app/bd/getMaScheme', {//getMaScheme2
                bdVid: this.bdVid,
                keywordId: this.keywordid,
                channelId: this.id,
                path: 'packageB/pages/baidu2/index'
            }).then(res => {
                console.log(res)
                window.location.href = res.data;
            })
        }, 
        
        getPhone() {
            this.isDanmu = true;
            setTimeout(() => {
                this.isDanmu = false;
                var num = Math.floor(Math.random() * 17);
                var list = [{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845065000751828992.jpg", name: "小笑玉" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059170669268992.jpg", name: "李冬丽" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059032240459776.jpg", name: "时光静好" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845057205503627264.jpg", name: "年年有余" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045951246471168.jpg", name: "一如既往" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045037685116928.jpg", name: "难得糊涂" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845044890985140224.jpg", name: "刘笑敏" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845010975356456960.jpg", name: "晨光曦影" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845002111324098560.jpg", name: "春暖花开" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845000414124150784.jpg", name: "风雨过林" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984893706178560.jpg", name: "谢长征" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984502872543232.jpg", name: "淡然接受" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844311874545487872.jpg", name: "旅途的人" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844288726492090368.jpg", name: "知足常乐" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844280029464334336.jpg", name: "谓我" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844238354637492224.png", name: "陈笑笑" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233814890614784.jpg", name: "丽笑丽" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233663568515072.jpg", name: "凌智科练" }]
                this.danmus.img = list[num].avatar;
                this.danmus.name = list[num].name;
                this.danmus.name = this.danmus.name.charAt(0) + '*'.repeat(this.danmus.name.length - 1) + this.danmus.name.charAt(this.danmus.name.length - 1);
                this.danmus.time = (Math.floor(Math.random() * 60) + 1) + '秒前';
            }, 1000)
        },
    }
}
</script>

<style scoped lang="less">
.qianwang_mengceng {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10076;

    .qianwang {
        position: fixed;
        left: 50%;
        top: 25%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        border-radius: 16px;
        width: 84%;
        padding: 50px;
        font-size: 32px;
        color: #666;
        transition: all 0.3s ease;
        text-align: center;

        .qw_top {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .img_log {
                width: 80px;
                height: 80px;
            }

            .dotting {
                display: flex;
                align-items: center;
                justify-content: space-around;
                width: 100px;

                .yuan {
                    width: 18px;
                    height: 18px;
                    border-radius: 20px;
                    background-color: #686868;
                    transition: all 0.3s ease;
                }

                .yuan2 {
                    width: 12px;
                    height: 12px;
                    border-radius: 20px;
                    background-color: #c5c5c5;
                    transition: all 0.3s ease;
                }
            }
        }
    }
}

.popup-content {
    width: 100%;
    background: #fff;
    color: #333;
    bottom: 0;
    left: 0;
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    border-radius: 50px 50px 0 0;
    z-index: 2002 !important;

    .top {
        padding: 40px 30px 100px 30px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 20px 0 60px 0;
        padding: 20px 0;

        .p-t-top {
            font-size: 48px;
            font-weight: 600;
            color: #ff6933;
            font-family: PingFangSC-Medium;
            display: flex;
            align-items: center;
            justify-content: center;

            .width70px {
                width: 70px;
            }
        }

        .p-t-bottom {
            margin-top: 10px;
            font-size: 32px;
            color: #666;
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ff790d;
        padding: 15px 30px 30px 30px;

        .left {
            color: #fff;
            font-size: 80px;
            line-height: 80px;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            flex-wrap: nowrap;
            flex-shrink: 0;
            position: relative;

            .unit {
                font-size: 30px;
                line-height: 30px;
                position: absolute;
                left: 0;
                top: 25px;
                display: inline-block;
                font-family: PingFangSC-Medium;
            }

            .deduct {
                background-color: #ffff3f;
                border-radius: 8px;
                color: #ff790d;
                font-size: 28px;
                padding: 5px;
                line-height: 25px;
                font-family: sans-serif;
            }

            .price {
                padding: 18px;
                font-weight: 700;
                font-family: PingFangSC-Medium;
            }
        }

        .right {
            color: #ff790d;
            background: rgb(255, 255, 255);
            width: 300px;
            height: 100px;
            line-height: 100px;
            border-radius: 50px;
            text-align: center;
            font-weight: 700;
            font-size: 50px;
            animation: identifier .7s linear infinite;
        }

        @keyframes identifier {
            0% {
                transform: scale(.95);
            }

            50% {
                transform: scale(1.02);
            }

            100% {
                transform: scale(.95);
            }
        }
    }
}

.popup_mengceng {
    z-index: 2001;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
}

@keyframes van-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.danmu {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 15vh;
    right: 20px;
    padding: 10px 20px;
    background: #00000075;
    color: #fff;
    font-size: 28px;
    border-radius: 50px;
    width: 60%;
}

.fade-in {
    animation: slide-up-fade-in 1s forwards;
}

@keyframes slide-up-fade-in {
    0% {
        transform: translateY(10px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.fade-out {
    animation: slide-up-fade-out 1s forwards;
}

@keyframes slide-up-fade-out {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        transform: translateY(-30px);
        opacity: 0;
    }
}

.content img {
    pointer-events: none;
    cursor: default;
}

.loading {
    margin: 40vh auto;
    text-align: center;

    .loading-text {
        color: #39CCCD;
        font-weight: bold;
    }
}

.container {
    color: #333;
    font-size: 28px;
    // height: 100vh !important;
    height: 100%;
    display: flex;
    flex-direction: column;

    .content {
        flex: 1;
        position: relative;
        // padding-bottom: 140px;
        // height: 100vh !important; 
        overflow-y: auto;
        width: 100%;

        ::v-deep img {
            display: block;
            width: 100% !important;
        }
    }
}

.header-bg {
    width: 100vw;
}

.footer-fit {
    flex-shrink: 0;
    // position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;
    // background-color: rgb(255, 250, 240);
    background-color: #ffffff;

    .bottom {
        padding: 20px 30px 30px 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;

        .bottom2 {
			font-weight: 600;
			background-color: #ff6933;
			color: #fff;
			width: 100%;
			padding: 18px;
			border-radius: 50px;
			text-align: center;
			font-size: 50px;
			font-family: sans-serif;
            animation: identifier .7s linear infinite;
        }

        @keyframes identifier {
            0% {
                transform: scale(.95);
            }

            50% {
                transform: scale(1.02);
            }

            100% {
                transform: scale(.95);
            }
        }
    }

    .left {
        // color: rgb(255, 36, 0);
        color: #ffffff;
        font-size: 42px;
        line-height: 40px;
        font-weight: 600;

        .left-qian {
            font-size: 45px;
            font-family: sans-serif;
        }
    }

    .right {
        position: relative;

        .finger {
            width: 100px;
            height: 100px;
            position: absolute;

            left: -60px;
            top: 50%;
            margin-top: -50px;

            z-index: 1;
            -webkit-animation: fadefinger 0.4s ease infinite alternate;
            animation: fadefinger 0.4s ease infinite alternate;
        }

        @keyframes identifier {
            0% {
                transform: scale(.95);
            }

            50% {
                transform: scale(1.02);
            }

            100% {
                transform: scale(.95);
            }
        }

        .btn {
            background-color: red;
            color: #fff;
            font-weight: 600;
            width: 300px;
            height: 100px;
            line-height: 100px;
            border-radius: 50px;
            text-align: center;
            animation: identifier .7s linear infinite;
            font-size: 44px;

            .grab {
                font-size: 22px;
                line-height: 22px;
                margin-bottom: 10px;
                padding-top: 10px;
            }

            .enroll {
                // line-height: 44px;
                line-height: 40px;
                font-weight: bold;
                font-size: 44px;
            }
        }
    }
}

@keyframes fadefinger {
    0% {
        transform: translateX(35px);
        -webkit-transform: translateX(35px);
    }

    100% {
        transform: translateX(0);
        -webkit-transform: translateX(0);
    }
}

@keyframes updown {
    0% {
        transform: translateY(8px);
        -webkit-transform: translateY(8px);
    }

    100% {
        transform: translateY(-8px);
        -webkit-transform: translateY(-8px);
    }
}


.van-popup {
    background: #f4f4f4;
}

.active {
    border: 4px solid #ff6d00 !important;
}
</style>